import { render, staticRenderFns } from "./OidcLogin.vue?vue&type=template&id=1df34f12"
import script from "./OidcLogin.vue?vue&type=script&lang=js"
export * from "./OidcLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports